import React from 'react';
import { FeatureContainer, FeatureButton, Road } from './RoadmapElements';

const Feature = () => {
  return (
    <FeatureContainer>
      <h1>Roadmap</h1>
      <FeatureButton></FeatureButton>
      <Road>Pre-sale Drop: CryptoBears giveaway to 50 lucky holders.</Road>
      <Road>50 Minted: Users can directly buy from Opensea.io</Road>
      <Road>900 NFT: Official launch of the NFT, users can directly mint from our website</Road>
      <Road>100% minted: Exclusive CryptoBearsClub holder party in the metaverse with live DJ and prizes!</Road>
    </FeatureContainer>
  );
};

export default Feature;
